export default "__VITE_ASSET__25da2077__"